import clsx from 'clsx';
import React, { ButtonHTMLAttributes } from 'react';
import { IconButton } from '../IconButton';
import './NavigationIconButton.less';

interface Props extends ButtonHTMLAttributes<HTMLButtonElement> {
  withShadow?: boolean;
  children: React.ReactNode;
}

export default function NavigationIconButton({
  children,
  withShadow = true,
  ...props
}: Props) {
  return (
    <IconButton
      {...props}
      withShadow={withShadow}
      className={clsx('navigation-icon-button__icon-button', props.className)}
    >
      {children}
    </IconButton>
  );
}
